/*
 * Module for the benefit details tab of the Benefit Summary screen
*/
rs.module("framework/benefitsummary/beneficiarydetails",

    [],
    function () {

    // Initialize function
        function initialize(jsSelectors) {
            var form = $.js(jsSelectors.form);
            var changeBeneficiaryLink = $.js(jsSelectors.changeBeneficiaryLink, { required: false });

            // Bind click event for the change beneficiary link
            changeBeneficiaryLink.on('click', function (e) {
                e.preventDefault();
                form.js(jsSelectors.changeBeneficiarySection).toggle(); // Toggle visibility of the section
                changeBeneficiaryLink.hide(); // Hide the link

                // Scroll to the bottom of the page
                $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
            });

            // Bind click event for Save and Cancel buttons
            form.js(jsSelectors.formActionsButton).click(function () {
            form.js(jsSelectors.changeBeneficiarySection).hide(); // Hide the section
            });
        }
        /// Exported public API
        var exports = {
            initialize: initialize
        };
        return exports;
    }
);